'use strict';

import {ferry} from '../../services/ferry/ferry';
import {validEmail} from "../../services/constants/emailRegex";

export default ['$scope','$routeParams', function($scope, $routeParams) {
    $scope.attemptingLogin = false;
    $scope.email = "";
    $scope.validEmail = validEmail;
    $scope.no_email_required = $routeParams.noemail;

    $scope.demoLogin = function() {
        $scope.attemptingLogin = true;
        analytics.track('demo started', {email: $scope.email.toLowerCase().trim()});
        ferry.call('/session/demo_login', { email: $scope.email.toLowerCase().trim() }).then(function() {
            analytics.track('Demo Login', {
                label: $scope.no_email_required ? 'No Email' : 'Email Provided'
            });
            $scope.attemptingLogin = true;
            document.location.href = '/app';
            $scope.$apply();
        }).catch(function() {
            $scope.showError = true;
            $scope.attemptingLogin = false;
            $scope.no_email_required = undefined;
            $scope.$apply();
        });
    };

    if ($scope.no_email_required) {
        $scope.email = 'noemail@equity.gust.com';
        $scope.demoLogin();
    }
}];



// WEBPACK FOOTER //
// ./_src/ui/preLoginApp/demo.js